import classnames from 'classnames';
import React from 'react';

import { appConfig } from './config';
import { Checkbox } from './form/fields/RadioCheck';
import { SearchFilter } from './form/SearchForm';
import { Div, Li, Ul } from './HTMLElement';
import { t } from './i18n/i18n';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface InnerSearchFiltersProps extends React.HTMLAttributes<HTMLDivElement> {
  enableSearchFromItem?: number;
  enableSearchFromWord?: number;
  filter: SearchFilter;
}

const InnerSearchFilters = ({
  enableSearchFromItem = 10,
  enableSearchFromWord = 3,
  filter,
}: InnerSearchFiltersProps) => {
  const [searchValue, setSearchValue] = React.useState('');

  const isActive = filter.children.length > enableSearchFromItem;

  const filteredItems = React.useMemo(() => {
    if (searchValue.length < enableSearchFromWord) return filter.children;
    return filter.children.filter((item) => item.filter.name?.toLowerCase().includes(searchValue));
  }, [enableSearchFromWord, filter.children, searchValue]);

  const { enableSearchInFilter } = appConfig;
  return (
    <Div className={'inner-search-filters'}>
      <fieldset>
        <legend className="visually-hidden">{filter.filter.name}</legend>
        {isActive && enableSearchInFilter && (
          <Div className="inner-search-filters-input-container">
            <input
              className={'inner-search-filters-input'}
              onChange={(e) => setSearchValue(e.currentTarget.value.toLowerCase())}
              placeholder={t('innerSearchFilter.search')}
              type="text"
              value={searchValue}
            />
          </Div>
        )}
        <Ul
          className={classnames('inner-search-filters-item-list', { 'is-active': enableSearchInFilter && isActive })}
          style={{
            listStyle: 'unset',
            overflowY: enableSearchInFilter && isActive ? 'scroll' : undefined,
          }}
        >
          {filteredItems.length > 0 ? (
            filteredItems.map((filterItem) => (
              <Li key={filterItem.checkbox.id}>
                {filterItem.children.length > 0 ? (
                  <InnerSearchFilters filter={filterItem} />
                ) : (
                  <Checkbox {...filterItem.checkbox} className="filter-item-checkbox" />
                )}
              </Li>
            ))
          ) : (
            <Li>{t('innerSearchFilter.noResults')}</Li>
          )}
        </Ul>
      </fieldset>
    </Div>
  );
};

export type InnerSearchFiltersVariants = '';

const InnerSearchFiltersController = (props: PropsWithCustomComponent<InnerSearchFiltersProps>) => (
  <VariantsController<InnerSearchFiltersProps, InnerSearchFiltersVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: InnerSearchFilters,
      name: 'InnerSearchFilters',
    }}
  />
);
export { InnerSearchFiltersController as InnerSearchFilters };
